import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=f8efa866&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"
import style0 from "./Board.vue?vue&type=style&index=0&id=f8efa866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8efa866",
  null
  
)

export default component.exports